import AgendaSummary from './AgendaSummary';

export default AgendaSummary;